import script from "./RbLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./RbLoader.vue?vue&type=script&setup=true&lang=js"

import "./RbLoader.vue?vue&type=style&index=0&id=1a8ecf65&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a8ecf65"]])

export default __exports__